import type { ActivityLog } from '../../types';

export const getLevelBadgeColor = (level: ActivityLog['level']) => {
  switch (level) {
    case 'Info':
      return 'success';
    case 'Problem':
      return 'danger';
    default:
      return 'secondary';
  }
};

export const getEventLabel = (event: ActivityLog['event']) => {
  switch (event) {
    case 'Liobo':
      return 'LIOBO';
    default:
      return event;
  }
};

export const formatLevel = (level: string | null | undefined) => {
  switch (level) {
    case 'Info':
      return 'Info';
    case 'Problem':
      return 'Problem';
    default:
      return level || '-';
  }
};

export const formatInitiator = (
  actorType: string | null | undefined,
  userName: string | null | undefined,
) => {
  switch (actorType?.toLowerCase()) {
    case 'customer':
      return 'Customer';
    case 'client service':
      return userName ? `Untamed (${userName})` : 'Untamed';
    case 'system':
      return 'Purrscribe';
    default:
      return actorType || '-';
  }
};

export const formatDate = (dateString: string) => {
  if (!dateString) return '-';

  const datePart = dateString.substring(0, 10); // 2025-09-16
  const timePart = dateString.substring(11, 16); // 03:00
  const [year, month, day] = datePart.split('-');

  return `${day}/${month}/${year} ${timePart}`;
};

export const shouldShowDetails = (log: ActivityLog): boolean => {
  return (
    (log.event === 'SKU Swapped' ||
      log.event === 'OOS SKU Skipped' ||
      log.event === 'MTO Blocked' ||
      log.event === 'Reprocess Subscription Contract Create Webhook') &&
    !!log.details
  );
};

export const getLioboMessage = (log: ActivityLog): string | null => {
  if (log.event === 'Liobo' && log.details?.message && typeof log.details.message === 'string') {
    return log.details.message;
  }
  return null;
};
